import { graphql } from 'gatsby'
import { normalizedData } from '@utils'
import Layout from '@layout'
import Header from '@layout/header/layout-01'
import Footer from '@layout/footer/layout-01'
import PageHeader from '@containers/page-header/layout-04'
import Text from '@containers/text/layout-01'
import StellungnahmenGutachtenArea from '@containers/stellungnahmen-gutachten/layout-01'

const StellungnahmenGutachtenPage = ({ location, data }) => {
  const content = normalizedData(data?.strapiPage?.content || [])

  return (
    <Layout location={location}>
      <Header />
      <main className="site-wrapper-reveal">
        <PageHeader
          data={{
            ...content['header-section']
          }}
        />
        <Text
          data={{
            ...content['einleitung-section']
          }}
        />
        <StellungnahmenGutachtenArea
          dataRegulierung={{
            ...content['regulierung-section']
          }}
          dataSteuern={{
            ...content['steuern-section']
          }}
          bg="white"
        />
      </main>
      <Footer />
    </Layout>
  )
}

export { Head } from '@components/head'

export const query = graphql`
  query StellungnahmenGutachtenPageQuery($title: String, $locale: String) {
    strapiPage(
      title: { eq: $title }
      pageType: { eq: "innerpage" }
      locale: { eq: $locale }
    ) {
      content {
        ...StrapiPageContent
      }
      seo {
        ...StrapiPageSEO
      }
    }
  }
`

export default StellungnahmenGutachtenPage
